import { BehaviorSubject } from "rxjs";
import { User } from "../models/global.model";

export const userDetail = new BehaviorSubject<User>({} as User);
export const userDetail$ = userDetail.asObservable();